import styled from 'styled-components';

import Checkbox from '../../../../components/Checkbox';
import Select from '../../../../components/Select';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  & .info-wrapper {
    margin-bottom: 24px;
    margin-top: 32px;
  }
`;

export const FieldsWrapper = styled.div`
  padding: 32px;
  height: 100%;
  overflow-y: auto;
`;

export const CustomCheck = styled(Checkbox)`
  width: 100%;
`;

export const CustomSelect = styled(Select)`
  width: 100%;
`;

export const FieldWrapper = styled.div`
  margin-top: 16px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`;
